module.exports = __webpack_public_path__ + "img/slide-20.c01c7f29.jpeg";